import * as React from 'react';

import { ILocalization } from '@shared-ui/localization-context';

import { UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSelect } from 'uitk-react-input';

import { RoomConfig } from 'components/common/room-picker/room-picker-model';

export interface ChildrenAgesProps {
  room: RoomConfig;
  childAge: number;
  childIndex: number;
  onChildAgeUpdated: (childIndex: number, target: any) => void;
  roomIndex: number;
  l10n: ILocalization;
  selectLabel: string;
  minChildAge: number;
  maxChildAge: number;
  isInfant: boolean;
}

export interface ChildAgeSelectOptions {
  value: string;
  name: string;
}

export const ChildrenAges = ({
  minChildAge,
  maxChildAge,
  childAge,
  childIndex,
  l10n,
  onChildAgeUpdated,
  roomIndex,
  selectLabel,
  isInfant,
}: ChildrenAgesProps) => {
  const options = getChildrenAgeSelectOptions(minChildAge, maxChildAge, l10n);

  // Need access to variables in scope.
  const updatedAges = (event: { target: any }) => onChildAgeUpdated(childIndex, event.target);

  const elementName = isInfant ? `infant-${roomIndex}-${childIndex}` : `child-${roomIndex}-${childIndex}`;
  const elementId = isInfant ? `infant-age-${childIndex}` : `age-${childIndex}`;

  return (
    <UitkLayoutGridItem colSpan={1}>
      <div>
        <UitkSelect label={selectLabel} id={elementId} name={elementName} value={childAge.toString()} onChange={updatedAges}>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          ))}
        </UitkSelect>
      </div>
    </UitkLayoutGridItem>
  );
};

const getChildrenAgeSelectOptions = (minChildAge: number, maxChildAge: number, l10n: ILocalization): ChildAgeSelectOptions[] => {
  const options: ChildAgeSelectOptions[] = [];
  for (let i = minChildAge; i <= maxChildAge; i++) {
    const name = i === 0 ? l10n.formatText('hotels.roomPicker.youngestChildAge.text') : i;

    options.push({
      value: `${i}`,
      name: `${name}`,
    });
  }

  return options;
};
